"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSenior = function IconSenior(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M14.5 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M9 10.382V22h2v-6h2v6h2V10.41c.649.17 1.313.395 2 .676V22h1V11.527q.248.116.5.242l.894-1.788C16.798 8.682 14.394 8 11.947 8s-4.85.682-7.447 1.98l.894 1.79C6.67 11.131 7.858 10.672 9 10.381"
  })));
};

export { IconSenior, IconSenior as default };
